import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';

import { usePublicLanguage } from './i18n/LanguageContext';
import './PublicTenderResponsive.css';
import privacyPolicyContent, {
  PRIVACY_IS_DRAFT,
  PRIVACY_LAST_UPDATED,
  PRIVACY_LAST_UPDATED_EN,
} from './privacyPolicyContent';

const PublicPrivacyPolicy = () => {
  const { language, t } = usePublicLanguage();

  useEffect(() => {
    document.title = t('privacy.documentTitle');
  }, [t]);

  const sections = privacyPolicyContent[language] || privacyPolicyContent.id;
  const lastUpdated =
    language === 'en' ? PRIVACY_LAST_UPDATED_EN : PRIVACY_LAST_UPDATED;

  return (
    <Card className='public-tender__card border-0 overflow-hidden'>
      {/* Panel hero meniru `.login-hero` halaman login; judul dibuat berteks
          terang karena berdiri di atas panel gelap. */}
      <div className='public-tender__hero public-tender__hero--compact'>
        <div className='public-tender__hero-overlay' aria-hidden='true' />
        <div className='public-tender__hero-accent' aria-hidden='true' />
        <div className='public-tender__hero-content'>
          <Link to='/tender-announcement' className='public-tender__back-link'>
            <i className='ri-arrow-left-line me-2' aria-hidden='true'></i>
            {t('privacy.back')}
          </Link>

          <div className='public-tender__detail-header'>
            <h1 className='public-tender__detail-title'>
              {t('privacy.title')}
            </h1>
            <p className='mb-0 mt-2 public-tender__hero-meta'>
              {t('privacy.lastUpdated', { date: lastUpdated })}
            </p>
          </div>
        </div>
      </div>

      <div className='public-tender__body'>
        {/* Peringatan naskah rancangan. Matikan lewat PRIVACY_IS_DRAFT hanya
            setelah isi kebijakan ditinjau Fungsi Legal & Compliance. */}
        {PRIVACY_IS_DRAFT && (
          <div className='alert alert-warning public-tender__privacy-notice'>
            <i className='ri-alert-line me-2' aria-hidden='true'></i>
            {t('privacy.draftNotice')}
          </div>
        )}

        <Card className='public-tender__detail-card'>
          <CardBody className='public-tender__privacy-body'>
            {sections.map(section => (
              <section
                key={section.heading}
                className='public-tender__privacy-section'
              >
                <h2 className='public-tender__privacy-heading'>
                  {section.heading}
                </h2>

                {section.paragraphs?.map(paragraph => (
                  <p key={paragraph}>{paragraph}</p>
                ))}

                {section.bullets && (
                  <ul className='public-tender__privacy-list'>
                    {section.bullets.map(bullet => (
                      <li key={bullet}>{bullet}</li>
                    ))}
                  </ul>
                )}
              </section>
            ))}
          </CardBody>
        </Card>
      </div>
    </Card>
  );
};

export default PublicPrivacyPolicy;
